// Google Analytics loader gated by consent.
// Only loads on the live domain and only after statistics consent.

import { hasStatisticsConsent, onConsentChange } from "./consent";

const GA_ID = "G-7J552LSK67";
const LIVE_HOST = "3d-druck-bolz.de";

let injected = false;

function isLiveHost(): boolean {
  return typeof window !== "undefined" && window.location.hostname === LIVE_HOST;
}

function ensureGtagStub() {
  if (typeof window === "undefined") return;
  window.dataLayer = window.dataLayer || [];
  if (typeof window.gtag !== "function") {
    window.gtag = function (...args: unknown[]) {
      (window.dataLayer as unknown[]).push(args);
    };
  }
}

export function loadGA(): void {
  if (typeof window === "undefined") return;
  if (!isLiveHost()) return;
  if (!hasStatisticsConsent()) return;
  if (injected) return;

  ensureGtagStub();
  (window as unknown as Record<string, boolean>)[`ga-disable-${GA_ID}`] = false;

  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  script.setAttribute("data-consent", "statistics");
  document.head.appendChild(script);

  window.gtag!("js", new Date());
  window.gtag!("config", GA_ID, { anonymize_ip: true, send_page_view: true });
  injected = true;
}

export function unloadGA(): void {
  if (typeof window === "undefined") return;
  (window as unknown as Record<string, boolean>)[`ga-disable-${GA_ID}`] = true;
  // Remove GA cookies (_ga, _ga_*, _gid, _gat*)
  const host = window.location.hostname;
  const domains = ["", host, `.${host}`, `.${host.replace(/^www\./, "")}`];
  document.cookie.split(";").forEach((c) => {
    const name = c.split("=")[0]?.trim();
    if (!name) return;
    if (/^_ga(_.*)?$|^_gid$|^_gat/.test(name)) {
      domains.forEach((d) => {
        document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/${d ? `; domain=${d}` : ""}`;
      });
    }
  });
  // Note: script tag isn't removed — reload effectively finalizes GA disable state.
}

// Auto-wire: react to future consent changes.
if (typeof window !== "undefined") {
  onConsentChange((v) => {
    if (v?.statistics) loadGA();
    else unloadGA();
  });
}
